import { Injectable } from '@angular/core';
import {
  ValidatorFn,
  FormGroup,
  ValidationErrors,
  FormArray,
  FormControl,
  AbstractControl
} from '@angular/forms';
import { AreaEnum } from '@bo-client/technician-management/tm-user/tm-user.model';

@Injectable({
  providedIn: 'root'
})
export class TmUserFormValidationService {
  constructor() {}

  contactItemValidator(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const errors: ValidationErrors = {};
      const contactAreas: AreaEnum[] = control.get('areas').value.filter((i) => i.selected);

      if (contactAreas.length == 0) {
        errors.areas = {
          message: 'Bitte wählen Sie mindestens eine Sparte aus'
        };
      }
      return Object.keys(errors).length ? errors : null;
    };
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  mustTrue(control) {
    const enteredValue = control.value;
    return !enteredValue ? { mustTrue: true } : null;
  }
}
